import React from "react";
import classes from './ErrorAlert.css';
import { FaInfoCircle } from "react-icons/fa";

const ErrorAlert = () => {
    return (
        <div className={[classes.alertMessageContainer].join(' ')}>
            <span>
            <FaInfoCircle color={"red"} fontSize={"30px"} style={{ marginRight: "10px" }} />
            </span>
            <span className={classes.alertMessage}>
                <p>Error</p>
            {' '}
            Please refresh the page and try again. If error persists, please follow process to report the issue.{' '}
            </span>
        </div>
    )
}

export default ErrorAlert;